import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // Main layout routes
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Routes
        // =============================================================================
        {
          path: '/',
          redirect: '',
          component: () => import('./views/Home'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        /**
         * Warehouse
         */
        {
          path: 'warehouse/products/',
          name: 'products',
          component: () => import('./views/products/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'warehouse/warehouses/',
          name: 'warehouses',
          component: () => import('./views/warehouses/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'warehouse/vehicles/',
          name: 'vehicles',
          component: () => import('./views/vehicles/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        /**End**/
        /**
         * Movements
         */
        {
          path: 'warehouse/inputs/',
          name: 'inputs',
          component: () => import('./views/inputs/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'warehouse/outputs/',
          name: 'outputs',
          component: () => import('./views/outputs/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'warehouse/transfers/',
          name: 'transfers',
          component: () => import('./views/transfers/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'warehouse/movements/',
          name: 'movements',
          component: () => import('./views/movements/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'warehouse/queries/',
          name: 'queries',
          component: () => import('./views/queries/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        /**End**/
        {
          path: 'warehouse/import/products',
          name: 'import',
          component: () => import('./views/import/ImportProducts'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'warehouse/import/stocks',
          name: 'import-stocks',
          component: () => import('./views/products/ImportStock'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        /**
         * Clients
         */
        {
          path: 'clients/list',
          name: 'clients-list',
          component: () => import('./views/clients/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'clients/addresses',
          name: 'clients-addresses',
          component: () => import('./views/clients/addresses/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'clients/contacts',
          name: 'clients-contacts',
          component: () => import('./views/clients/contacts/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        /**End**/
        /**
         * Providers
         */
        {
          path: 'providers/list',
          name: 'providers-list',
          component: () => import('./views/providers/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'providers/addresses',
          name: 'providers-addresses',
          component: () => import('./views/providers/addresses/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'providers/contacts',
          name: 'providers-contacts',
          component: () => import('./views/providers/contacts/App'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        /**End**/
        /**
         * Sales
         */
        {
          path: 'sales/quotes',
          name: 'sales-quotes',
          component: () => import('./views/quotes/App.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'sales/purchases',
          name: 'sales-purchases',
          component: () => import('./views/purchases/App.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'sales/guides',
          name: 'sales-guides',
          component: () => import('./views/guides/App.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'sales/invoices',
          name: 'sales-invoices',
          component: () => import('./views/sales/App.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'sales/credits',
          name: 'sales-credits',
          component: () => import('./views/credits/App.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        /**End**/
        /**
         * Purchases
         */
        {
          path: 'purchases/invoices',
          name: 'purchases-invoices',
          component: () => import('./views/invoices/App.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        /**
         * Settings
         */
        {
          path: 'settings/users',
          name: 'users',
          component: () => import('./views/users/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'settings/content',
          name: 'settings',
          component: () => import('./views/Content.vue'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('./views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        /**
         * Imports
         */
        {
          path: 'imports/products',
          name: 'import-products',
          component: () => import('./views/import/ImportProducts'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'imports/clients',
          name: 'import-clients',
          component: () => import('./views/import/ImportClients'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'imports/addresses-c',
          name: 'import-addresses-c',
          component: () => import('./views/import/ImportAddressesC'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'imports/contacts-c',
          name: 'import-contacts-c',
          component: () => import('./views/import/ImportContactsC'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'imports/providers',
          name: 'import-providers',
          component: () => import('./views/import/ImportProviders'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'imports/addresses-p',
          name: 'import-addresses-p',
          component: () => import('./views/import/ImportAddressesP'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'imports/contacts-p',
          name: 'import-contacts-p',
          component: () => import('./views/import/ImportContactsP'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'imports/import-sales',
          name: 'import-sales',
          component: () => import('./views/import/ImportSales'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        }
      ]
    },
    // Full Page Layout
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/login/Login.vue'),
          meta: {
            rule: 'editor',
          }
        },
        // Redirect to 404 page, if no match found
        {
          path: '*',
          redirect: '/pages/error-404',
          meta: {
            rule: 'editor'
          }
        }
      ]
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    // If auth required, check login. If login fails redirect to login page

    if (to.meta.authRequired) {
      if (!(firebaseCurrentUser)) {
        router.push({ path: '/pages/login', query: { to: to.path } })
      }
    }
    return next()
  })
})

export default router
